import React, { forwardRef, useEffect } from 'react'
import { pick } from 'lodash-es'
import { Popup } from '@ow/comps'
import styled from '@emotion/styled'
import { useTbViewStore, useDetailStore } from '@vt/hooks'
import DetailHeader from '../../../../details/detailHeader'
import Detail from './detail'
import useArticleDetail from './use-detail'

const StyledDetailWrapper = styled.div`
  .detail {
    width: 1200px;
  }
  @media screen and (max-width: 1200px) {
    .detail {
      width: 100%;
      padding: 0 20px;
    }
  }
`

export default forwardRef(({ closeModal, data }, ref) => {
  const { fetchTbDataById } = useTbViewStore((state) =>
    pick(state, ['fetchTbDataById'])
  )
  const { setCurrentData, currentData } = useDetailStore((state) =>
    pick(state, ['setCurrentData', 'currentData'])
  )
  const { size } = useArticleDetail()

  useEffect(() => {
    if (data) {
      fetchTbDataById(data.objectId).then((res) => {
        console.log(res, 'resresere')
        if (res && res.currentData) {
          setCurrentData(res.currentData)
        }
      })
    }
  }, [data])

  return (
    <Popup
      ref={ref}
      closeOnDocumentClick={false}
      contentStyle={{
        background: '#fff',
        width: size === 'small' ? '90%' : '100%',
        height: size === 'small' ? '90%' : '100%',
        overflow: 'hidden',
      }}
      className="h-full dark:bg-darkTheme-1100"
      closeOnEscape={false}
    >
      {currentData && (
        <div className="h-full flex flex-col overflow-hidden ">
          <DetailHeader
            title="文章详情"
            close={() => {
              setCurrentData({})
              ref.current.close()
              closeModal()
            }}
            onClickNextOrPrev={(e) => {
              if (e.data) {
                setCurrentData(e.data)
              }
            }}
          />
          <StyledDetailWrapper className="overflow-y-auto">
            <div className="flex-1 mx-auto detail">
              {/* <div className="flex-1 mx-auto px-10" style={{ width: '1200px' }}> */}
              <Detail detailData={currentData} />
            </div>
          </StyledDetailWrapper>
        </div>
      )}
    </Popup>
  )
})
